import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer, EuiButton } from '@elastic/eui';
import SelectCards from 'components/Outdoor_Cameras/IN-9808_QFHD/Quick_Installation/PoE_or_WiFi/SelectCards';
import NavButtons from 'components/Outdoor_Cameras/IN-9808_QFHD/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  EuiButton,
  SelectCards,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};